import { render, staticRenderFns } from "./Wp_robot_tools.vue?vue&type=template&id=bdc31b26&scoped=true&"
import script from "./Wp_robot_tools.vue?vue&type=script&lang=js&"
export * from "./Wp_robot_tools.vue?vue&type=script&lang=js&"
import style0 from "./Wp_robot_tools.vue?vue&type=style&index=0&id=bdc31b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc31b26",
  null
  
)

export default component.exports